import React from 'react';
import { useAnalytics } from '..';
export const AnalyticsHandlerRegistrant = handler => {
  const {
    addHandler,
    removeHandler
  } = useAnalytics();
  React.useEffect(() => {
    addHandler(handler);
    return () => {
      removeHandler(handler);
    };
  }, [addHandler, removeHandler, handler]);
  return null;
};